import { useSetMarketingInfoRequest } from '../data';
import { useEffect } from 'react';
import { apiStatuses, routesPaths } from '@selfserve/react-utils';

interface Props {
  subscriptionId: string;
  data: any;
}

export const Redirector = ({ subscriptionId, data }: Props) => {
  const { mutateAsync: handleUpdateRequest, data: updateData } =
    useSetMarketingInfoRequest(subscriptionId);

  useEffect(() => {
    handleUpdateRequest({
      userData: data,
    });
  }, [handleUpdateRequest, data]);

  useEffect(() => {
    if (updateData?.status && updateData?.status === apiStatuses.CREATED) {
      window.location.href = updateData?.data?.url as string;
    }
  }, [updateData]);

  return null;
};
